import { Pipe, PipeTransform } from '@angular/core';
import {ResourceType} from "../../../core/helpers/Const";
import {Utils} from "../../../core/helpers/Utils";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

@Pipe({
    name: 'resourceGlyph',
    standalone: false
})
export class ResourceGlyphPipe implements PipeTransform {
    transform(resourceType: ResourceType): IconProp {
        return Utils.getFontAwesomeResourceGlyph(resourceType);
    }
}
